import { useContent } from "@/shared/lib/i18n";

export function Payouts() {
  const { payouts } = useContent();

  return (
    <section className="py-16 px-[14px] lg:py-24 lg:px-8" id="payouts">
      <div className="mx-auto max-w-[1760px]">
        {/* Heading */}
        <div className="text-center mb-8 lg:mb-16">
          <h2 className="font-display text-[32px] lg:text-[76px] leading-tight lg:leading-[1.1] text-white mb-4">
            {payouts.titleLead}
            <br />
            <span style={{ color: "#fec201" }}>{payouts.titleAccent}</span>
          </h2>
          <p className="text-[15px] lg:text-[20px] max-w-[780px] mx-auto leading-relaxed">
            {payouts.subtitle}
          </p>
        </div>

        {/* Map + payment methods */}
        <div className="relative mx-auto max-w-[900px]">
          <img src="/planet.png" alt="" className="w-full" />
        </div>
      </div>
    </section>
  );
}
